import {Location} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {AppService} from '../../../../../../app.service';
import {AuthService} from '../../../../../../core/auth/auth.service';
import {DialogService} from '../../../../../../core/services/dialog.service';
import {CustomerData} from '../../../../interfaces/customer-data';
import {Claim2CustomerI} from '../../../../interfaces/claim.interface';
import {CustomerI} from '../../../../interfaces/customer.interface';
import {CustomerDomainI} from '../../../../interfaces/customer-domain.interface';

@Component({
  selector: 'app-customer-edit',
  templateUrl: './customer-edit.component.html',
  styleUrls: ['./customer-edit.component.scss']
})
export class CustomerEditComponent implements OnInit {

  customerId: string;
  customerData: CustomerData;
  public customerForm = null;
  public c2cForm = this.fb.group({});
  public domainsForm = this.fb.group({});

  constructor(private route: ActivatedRoute,
              public location: Location,
              public app: AppService,
              public fb: FormBuilder,
              private auth: AuthService,
              public dialog: DialogService) {
    this.customerId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.getCustomerData();
  }

  getCustomerData(): void {
    if (this.customerId) {
      this.app.dialog.loader({
        title: 'Laden von Kundendaten'
      });
      this.app.customerData(this.customerId).then(data => {
        // console.log(data);
        this.initCustomerForm(data.customer);
        this.initClaimsForm(data);
        this.initDomainsForm(data.customer.customerDomains);
        this.customerData = data;
        this.app.dialog.closeLoader();
      });
    }
  }

  initCustomerForm(customer: CustomerI) {
    this.customerForm = this.fb.group({
      name: this.fb.control(customer.name, Validators.required)
    })
  }

  initClaimsForm(data: CustomerData) {
    if (data.scopedClaims2customer) {
      data.scopedClaims2customer.forEach(scope => {
        scope.claims.forEach(c2c => {
          this.c2cForm.addControl(
            c2c.external_claim_id,
            this.fb.group({
              'scope': c2c.scope,
              'claim_name': c2c.claim_name,
              'claim_value': c2c.claim_value === 'true',
              'external_claim_id': {value: c2c.external_claim_id, disabled: true},
              'start': c2c.start,
              'expires': c2c.expires,
              'max_user_count': c2c.max_user_count,
              'max_sessions_per_user': c2c.max_sessions_per_user,
            }))
        })
      })
    }
  }

  initDomainsForm(domains: CustomerDomainI[]) {
    if (domains && domains.length) {
      domains.forEach(d => {
        let domainExist = this.domainsForm.get(d.id);
        if (!domainExist) {
          this.domainsForm.addControl(
            d.id,
            this.fb.group({
              'domains': d.domains.join(', '),
              'start': d.start,
              'expiry': d.expiry,
              'renewal': d.renewal === '1',
              'claim_name': d.claimName,
              'term': d.term,
            }))
        }
      })
    }
  }

  getClaimDesc(name: string) {
    if (this.app.claims && name) {
      const claim = this.app.claims.find(c => c.name === name);
      return claim?.desc || name;
    } else if (!name) {
      name = 'Nuer Zugang'
    }
    return name;
  }

  getClaimForm(c: Claim2CustomerI): FormGroup {
    const fg = this.c2cForm.get(c.external_claim_id) as FormGroup;
    return fg || null;
  }

  getDomainForm(d: CustomerDomainI): FormGroup {
    const fg = this.domainsForm.get(d.id) as FormGroup;
    return fg || null;
  }

  privateClaim(c: Claim2CustomerI) {
    return c.external_customer_id.includes('@');
  }

  saveCustomer() {
    if (this.customerForm.valid) {
      const customer = Object.assign({}, this.customerData.customer) as CustomerI;
      const customerValues = this.customerForm.value as { [key: string]: string | boolean };
      customer.name = customerValues.name as string;

      this.app.customerUpdate(customer, this.auth.user.id).then(res => {
        if (res) {
          this.customerData.customer = customer;
          this.app.toast.open('Der Kunde wurde aktualisiert');
        }
      }).catch(() => {
        this.app.toast.open('Unbekannter Fehler', null, {
          panelClass: 'warn'
        });
      });
    } else {
      console.log('form invalid');
    }
  }

  addCustomer2Domain() {
    let expiry = new Date();
    expiry.setMonth(expiry.getMonth() + 3);
    const domain: CustomerDomainI = {
      claimName: '',
      customerId: this.customerData.customer.id,
      domains: [],
      expiry: expiry.toISOString(),
      id: '0',
      renewal: '0',
      start: (new Date()).toISOString(),
      term: 3
    };
    this.initDomainsForm([domain]);
    if (this.customerData.customer.customerDomains) {
      let domainExist = this.customerData.customer.customerDomains.find(d => d.id === domain.id);
      if (!domainExist) {
        this.customerData.customer.customerDomains.push(domain)
      }
    } else {
      this.customerData.customer.customerDomains = [domain];
    }
  }

  removeCustomer2Domain(domain: CustomerDomainI) {
    const i = this.customerData.customer.customerDomains.findIndex(d => d.id === domain.id);
    if (i > -1) {
      this.customerData.customer.customerDomains.splice(i, 1);
      this.domainsForm.removeControl(domain.id);
    }
  }

}
